import React from "react";
import Login from "../components/login";
import Header from "../components/Layouts/Header";

const LoginPage = () => {
  return (
    <>
      <Header />
      <Login />
    </>
  );
};

export default LoginPage;
